<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{ lang($store, 'sap/listings.not_found') }}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-row
              class="py-4"
            >
              <v-col
                v-for="(item, key) in paginatedObject.data"
                :key="'col_' + key"
                cols="12" lg="3"
                md="4" sm="6"
                class="py-1"
              >
                <v-card
                  class="pa-1 px-4 py-4 cyan"
                >
                  <div>
                    <div style="display: none">{{ item.uuid }}</div>
                    <div class="d-flex flex-row justify-space-between">
                      <div class="white--text">{{ item.region_formatted }}</div>
                      <router-link :to="{ name: 'order.pricing.show', params: { pricingUuid: item.uuid }}">
                        <v-icon small class="white--text">mdi-briefcase-edit-outline</v-icon>
                      </router-link>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* proxies */
import OrderPricingProxy from '@/proxies/OrderPricing/OrderPricingProxy';
/* utils */
import { roles as rolesColors } from '@/utils/listingColors';
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
/* components */
import CommentInput from '@/components/minialerts/CommentInput.vue';
import TrashButton from '@/components/minialerts/TrashButton.vue';


export default {
  name: 'TablePaginatedOrderPricing',
  components: {
    TrashButton,
    CommentInput,
  },
  mixins: [isComponentLoading],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      rolesColors,
      L: _,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
    onItemCopy(item) {
      this.$emit('copy-item', item);
    },
    onPreview(item) {
      this.$emit('preview-item', item);
    },

    getUpdateSimpleRequestClient() {
      return new OrderPricingProxy();
    },
  },
};
</script>

<style lang="sass" scoped>
.table-action
  &:hover
    fill: #0066ff
    transition: fill 0.5s
    cursor: pointer
</style>
